/**
 * The example request the Developer → API page shows (ADR-019). Placeholder
 * values only: the key is never a real one (keys are shown once, at
 * creation, on the API keys page) and the numbers are in the fictional
 * +1 555 01xx range.
 */
export const SEND_MSG_PATH = "/v1/send-msg";
export const API_KEY_PLACEHOLDER = "YOUR_API_KEY";

export interface SendMsgExample {
  templateId: string;
  uid: string;
  to: string;
  from: string;
  type: string;
  /** Omitted from the body when empty: the server's default trunk applies. */
  trunk: string;
}

export function sendMsgBody(example: SendMsgExample): Record<string, string> {
  const body: Record<string, string> = {
    channel: "voice",
    uid: example.uid,
    to: example.to,
    from: example.from,
    "template-id": example.templateId,
    type: example.type,
  };
  if (example.trunk) body.trunk = example.trunk;
  return body;
}

/** POSIX-shell single-quoting: safe for any value, including quotes. */
function shellQuote(value: string): string {
  return `'${value.replace(/'/g, `'\\''`)}'`;
}

export function sendMsgCurl(baseUrl: string, example: SendMsgExample): string {
  const url = `${baseUrl.replace(/\/+$/, "")}${SEND_MSG_PATH}`;
  const body = JSON.stringify(sendMsgBody(example), null, 4);
  return [
    `curl --location ${shellQuote(url)} \\`,
    `--header ${shellQuote(`x-api-key: ${API_KEY_PLACEHOLDER}`)} \\`,
    `--header 'Content-Type: application/json' \\`,
    `--data ${shellQuote(body)}`,
  ].join("\n");
}
